// import store from 'store'
import actions from './actions'

const STORED_SETTINGS = storedSettings => {
  // const settings = {}
  // Object.keys(storedSettings).forEach(key => {
  //   const item = store.get(`app.settings.${key}`)
  //   settings[key] = typeof item !== 'undefined' ? item : storedSettings[key]
  // })
  return storedSettings
}

const initialState = {
  ...STORED_SETTINGS({
    authProvider: 'firebase', // firebase, jwt
    logo: 'PIMS',
    locale: 'en-US',
    isSidebarOpen: false,
    isSupportChatOpen: false,
    isMobileView: false,
    isMobileMenuOpen: false,
    isMenuCollapsed: false,
    menuLayoutType: 'left', // left, top, nomenu
    routerAnimation: 'slide-fadein-up', // none, slide-fadein-up, slide-fadein-right, fadein, zoom-fadein
    menuColor: 'gray', // white, dark, gray
    theme: 'default', // default, dark
    authPagesColor: 'white', // white, gray, image
    primaryColor: '#499E51', // '#4b7cf3',
    leftMenuWidth: 256,
    isMenuUnfixed: false,
    isMenuShadow: false,
    isTopbarFixed: true,
    isGrayTopbar: false,
    isContentMaxWidth: false,
    isAppMaxWidth: false,
    isGrayBackground: false,
    isCardShadow: false,
    isSquaredBorders: false,
    isBorderless: false,
    copyrightText: 'Copyright © 2017-2020 Pest Information Management System',
  }),
}

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
